<template>
	<div class="flyer-thumb-button"
		:class="dynamicClasses" @click="gotoFlyer" :aria-label="title">
		<div class="image-container">
			<div class="overlay-wrapper" :class="isPreview ? 'preview' : ''" data-label="Preview">
				<aspect-img class="thumbnail" :src="thumbnail" :alt="flyerId"  :title="title" aspect-ratio="96:72" />
				<svg v-if="isPreview" class="overlay triangle" viewBox="127.8511 87.4968 88.1398 25.3117"
					width="88.1398" height="25.3117" xmlns="http://www.w3.org/2000/svg" xmlns:bx="https://boxy-svg.com">
					<path class="preview-svg" d="M 111.274 109.635 L 117.592 116.227 L 104.957 116.227 L 111.274 109.635 Z"
						style="stroke: rgb(0, 0, 0); stroke-width: 0px; transform-origin: 111.276px 112.931px;"
						transform="matrix(-0.087081998587, -0.996200919151, 0.993576109409, -0.117117002606, 20.399955624212, -6.80346138157)"
						bx:shape="triangle 104.957 109.635 12.635 6.592 0.5 0 1@283031df" />

				</svg>
				<svg v-if="isPreview" class="overlay" viewBox="127.8511 87.4968 88.1398 25.3117" width="88.1398"
					height="25.3117" xmlns="http://www.w3.org/2000/svg" xmlns:bx="https://boxy-svg.com">

					<rect class="preview-svg" x="-174.054" y="-133.358" width="87.622" height="18.741"
						style="stroke: rgb(0, 0, 0); stroke-width: 0px; transform-origin: -130.244px -123.987px;"
						transform="matrix(-0.999996006489, 0.002944000531, -0.002475000452, -0.999996960163, 302.401947877153, 220.982758018626)" />
				</svg>
				<div v-if="isPreview" class="overlay-text">{{ content.preview }}</div>
			</div>
		</div>
		<div class="details">
			<div class="title">{{ flyerTitle }}</div>
			<div class="dates">{{ ` ${startDate} - ${endDate}` }}</div>
		</div>

	</div>
</template>

<script>
import featureMixin from "@/mixins/featureMixin";
import moment from "moment";
import { mapGetters } from "vuex";
import AspectImg from "@/components/image/AspectImg.vue";
import Rest from "@/api/Rest";
import Lytics from "../../classes/Lytics";

export default {
	name: "FlyerThumbButton",
	components: { AspectImg },
	mixins: [featureMixin],
	props: {
		flyerData: {
			type: Object
		}
	},
	data() {
		return {
			featurePath: 'flyerSelector.flyerThumb'
		}
	},
	computed: {
		...mapGetters('landingPage', ['currentFlyer']),
		...mapGetters(['language', 'content']),
		...mapGetters('screen', ['displayMode', 'flyerOrientation']),
		isVertical() {
			return this.flyerOrientation === 'vertical';
		},
		isMobile() {
			return this.displayMode === 'mobile';
		},
		dateFormat() {
			return this.config?.dateFormat || '';
		},
		startDate() {
			return this.formatDate(this.flyerData.startDate);
		},
		endDate() {
			return this.formatDate(this.flyerData.endDate);
		},
		flyerId() {
			return this.flyerData.title;
		},
		flyerTitle() {
			return this.flyerData.flyerTitle.replace('(', '\u200B(');
		},
		isActive() {
			return this.flyerId === this.currentFlyer.title;
		},
		isConfigurable() {
			return  this.flyerOrientation === 'vertical' && this.displayMode === 'desktop' && this.flyerDrawer;
		},
		thumbnail() {
			return this.flyerData?.thumbnail;
		},
		flyerDrawer() {
            return this.features.flyerSelector._flyerOrientation['+vertical']?.['_display']?.['+desktop']?.position === 'left';
		},
		valid() {
			return this.content.landing.valid;
		},
		title() {
			return this.flyerData?.flyerTitle;
		},
		flyerType() {
			return this.flyerData?.flyerType;
		},
		isPreview() {
			return this.flyerType === 'preview';
		},
		preview() {
			return this.content?.flyerSelector?.previewFlyer
		},
		dynamicClasses() {
			return {
				active: this.isActive,
			    preview: this.isPreview,
			    mobile: this.isMobile,
			    vertical: this.isVertical,
				configurable: this.isConfigurable
			}

		}

	},
	methods: {
		formatDate(d) {
			return moment.utc(d).locale(this.language).format(this.dateFormat);
		},
		gotoFlyer() {
			Lytics.TriggerDrawerChange();
			if (!this.isActive) Rest.NavigateToFlyer(this.flyerId);
		}
	}
}
</script>

<style lang="scss" scoped>
.flyer-thumb-button.vertical.configurable {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	cursor: pointer;


}
.flyer-thumb-button {
	border: 0;
	box-shadow: none;
	color: #000;
	font-size: 0.7em;

	&.active {
		box-shadow: none;
		background: #ebebeb;
		border: solid 2px var(--secondary-color);

	}

	&:hover {
		background: #ebebeb;

		button {
			text-decoration: underline;
		}
	}

	.details {
        .dates {
			font-weight: unset;
            font-family: 'Lato Bold', sans-serif;
		}
	}

	.image-container {
		.overlay-wrapper {
			img {
				width: 100%;
				border: none;
			}
		}

		.overlay-wrapper.preview {
			position: relative;
			z-index: 2;

			.overlay {
				position: absolute;
				top: 57%;
				left: -6.5px;
				z-index: 1;

				path {
					fill: #333333;
					-webkit-filter: brightness(50%);
					filter: brightness(50%);
				}

				rect {
					fill: #333333;

				}
			}

			.overlay-text {
				position: absolute;
				top: 59%;
				left: 14%;
				z-index: 2;
				color: white;
			}

			.overlay.triangle {
				z-index: -1;
				top: 57%;
				left: -6.3px !important;
			}


		}
	}

	&.preview {

		.overlay {
			position: absolute;
			top: 0;
			left: 0;
			bottom: 0;
			right: 0;
		}
	}
}

.flyer-thumb-button.vertical {
	padding: 0.5em;
	color: #000;
	font-size: 0.7em;
	display: grid;
	grid-template-columns: 1fr 0.85fr;
	row-gap: 0.5em;
	justify-content: space-between;
	cursor: pointer;

	&.active {
		box-shadow: none;
		background: #ebebeb;
		border: solid 2px var(--secondary-color);
	}

	&:hover {
		background: #ebebeb;

		button {
			text-decoration: underline;
		}
	}

	.details {
		display: flex;
		flex-direction: column;
		justify-content: center;
		font-size: 1.1em;
		margin-left: 6px;
		max-width: 8em;
		min-width: 8em;

		.dates {

			//font-weight: bold;
			color: #434343;
			font-size: 0.9em;
		}

		.title {
			color: #636363;
			font-size: 1.1em;
			margin-bottom: 2px;

		}
	}

	.image-container {
		max-width: 10em;

		.overlay-wrapper {
			img {
				width: 100%;
				border: none;
			}
		}

		.overlay-wrapper.preview {
			position: relative;

			.overlay {
				left: -6.5px;

			}
		}
	}


	&.preview {
		.overlay {
			position: absolute;
			top: 0;
			left: 0;
			bottom: 0;
			right: 0;
			// background: rgba(117, 117, 117, 0.8);
		}
	}

	.title {
		font-size: 1em;
	}
}

.flyer-thumb-button.vertical.mobile {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	cursor: pointer;

	.text-overlay {
		transform: translate(-95%, 74%);
	}

	.details {
		font-size: 1.1em;
		max-width: 9em;
		min-width: 9em;
	}

	.title {
		font-size: 0.9em;
	}

	.dates {
		max-width: unset;
	}

	.overlay-wrapper.preview {

		.overlay {
			left: -6px !important;
		}
	}
}

.flyer-thumb-button.vertical {
	border: none;
}
</style>
